module.exports = "https://www.gc-pro.gnp.com.mx/a1d381dfc1df73e6173f9945f5829b29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-video-19.jpg
// module id = 946
// module chunks = 0 1